import React, { useReducer } from "react";
import DispositivoContext from "./dispositivoContext";
import DispositivoReducer from "./dispositivoReducer";

import clienteAxios from "../../service/axios";

import {
  OBTENER_DISPOSITIVOS,
  AGREGAR_DISPOSITIVO,
  ELIMINAR_DISPOSITIVO,
  ACTUALIZAR_DISPOSITIVO,
  DISPOSITIVO_ERROR,
  DISPOSITIVO_OK,
  DISPOSITIVO_ACTUAL,
  OBTENER_DISPOSITIVO,
  OBTENER_DISPOSITIVOS_SUPERVISADOS,
  OBTENER_DISPOSITIVOS_POLICIA_SUPERVISADOS
} from "types/context";
import serviceBack from "service/serviceBack";

const DispositivoState = (props) => {
  const initialState = {
    dispositivos: [], // dispositivos del cliente
    dispositivo: null,
    cliente: null,
    reload: false,
    formulario: false,
    errorformulario: false,
    mensaje: null,
    dispositivosSupervisados: []
  };

  const [state, dispatch] = useReducer(DispositivoReducer, initialState);

  const obtenerDispositivosSupervisados = async ({ estados, clienteId, tipo }) => {
    try {
      // siempre deberia venir un cliente
      let resultado;
      if (clienteId) {
        resultado = await clienteAxios.get(`/dispositivos/supervisados/?estados=${estados}&cliente=${clienteId}&supervision=LOCAL&tipo=${tipo}`);
      } else {
        resultado = await clienteAxios.get(`/dispositivos/supervisados/?estados=${estados}&supervision=POLICIAL&tipo=${tipo}`);
      }


      //console.log("context =>",resultado.data.dispositivosSupervisados);
      dispatch({
        type: OBTENER_DISPOSITIVOS_SUPERVISADOS,
        payload: resultado.data.dispositivosSupervisados
      });
      return resultado.data.dispositivosSupervisados;
    } catch (error) {
      //console.log(error)
      const alerta = {
        msg: error,
        categoria: 'error'
      }
      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta
      })
    }
  }

  // Filtra por un cliente si es necesario
  const obtenerDispositivosPoliciaSupervisados = async()=>{
  //OBTENER_DISPOSITIVOS_POLICIA_SUPERVISADOS

    try {
      // siempre deberia venir un cliente
      let resultado;
      resultado = await clienteAxios.get(`/dispositivos/supervisadosPolicial`);
      //console.log("context =>",resultado.data.dispositivosSupervisados);
      dispatch({
        type: OBTENER_DISPOSITIVOS_POLICIA_SUPERVISADOS,
        payload: resultado.data.dispositivosSupervisados
      });
      return resultado.data.dispositivosSupervisados;
    } catch (error) {
      //console.log(error)
      const alerta = {
        msg: error,
        categoria: 'error'
      }
      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta
      })
    }

  }

  const obtenerDispositivosInactividad = async ({ estados, clienteId, tipo }) => {
    try {
      // siempre deberia venir un cliente
      let resultado;

      if (clienteId) {
        resultado = await clienteAxios.get(`/logs/dispositivo-inactividad?estados=${estados}&cliente=${clienteId}&supervision=LOCAL&tipo=${tipo}`);
      } else {
        resultado = await clienteAxios.get(`/notificaciones/inactividad?estados=${estados}&supervision=POLICIAL&tipo=${tipo}`);
      }

      //console.log("context =>",resultado.data.salida);
      dispatch({
        type: OBTENER_DISPOSITIVOS_SUPERVISADOS,
        payload: resultado.data.notificacionesInactividad
      });
      return resultado.data.notificacionesInactividad;  
    } catch (error) {
      console.log(error)
      const alerta = {
        msg: error,
        categoria: 'error'
      }
      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta
      })
    }
  }

  // Obtener los Dispositivos
  const SIZE_PAGE = 20;
  const obtenerDispositivos = async (
    clienteId,
    grupoId = null,
    subgrupoId = null,
    pagina
  ) => {
    try {
      // siempre deberia venir un cliente
      // armo la url
      let urlDispositivos = "/dispositivos";
      let resultado;
      if (clienteId) {
        urlDispositivos += `?clienteId=${clienteId}`;
        if (grupoId) {
          urlDispositivos += `?grupoId=${grupoId}`;
          if (subgrupoId) {
            urlDispositivos += `?subgrupoId=${subgrupoId}`;
          }
        }
        resultado = await clienteAxios.get(urlDispositivos,
          pagina ? {
              params: {
                pagina: pagina,
                tamanioPagina: SIZE_PAGE, //***criticalbefore=4After=SIZE_PAGE
              },
            } 
          : 
            {
            params: {
              pagina: 1,
              tamanioPagina: 100,
            },
          }
        );
      } else {
        resultado = await clienteAxios.get(urlDispositivos,
          pagina ? {
              params: {
                pagina: pagina,
                tamanioPagina: SIZE_PAGE,
              },
            } 
          : 
            {
            params: {
              pagina: 1,
              tamanioPagina: 100,
            },
          }
        );
      }

      //console.log(resultado);
      dispatch({
        type: OBTENER_DISPOSITIVOS,
        payload: resultado.data.dispositivos || [],
      });
      //console.log("Obtener Dispositivos")
      return resultado?.data?.dispositivos || [];
    } catch (error) {
      const alerta = {
        msg: error.response.data.message,
        categoria: "error",
      };
      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta,
      });
    }
  };

  // Agregar nuevo dispositivo
  const agregarDispositivo = async (dispositivo) => {
    try {
      const resultado = await clienteAxios.post("/dispositivos", dispositivo);
      //console.log(resultado);
      // Insertar el dispositivo en el estado
      dispatch({
        type: AGREGAR_DISPOSITIVO,
        payload: resultado.data.dispositivo,
      });
      const alerta = {
        msg: "Dispositivo agregado con exito",
        categoria: 'exito'
      }
      dispatch({
        type: DISPOSITIVO_OK,
        payload: alerta
      })
      return resultado;
    } catch (error) {

      const alerta = {
        msg: error.response.data.message,
        categoria: "error",
      };
      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta,
      });
      return alerta;
    }
  };
  // Selecciona el dispositivo que el usuario dio click
  const dispositivoActual = (dispositivoId) => {
    dispatch({
      type: DISPOSITIVO_ACTUAL,
      payload: dispositivoId,
    });
  };

  // Elimina un dispositivo
  const eliminarDispositivo = async (dispositivoId) => {
    try {
      await clienteAxios.delete(`/dispositivos/${dispositivoId}`);
      dispatch({
        type: ELIMINAR_DISPOSITIVO,
        payload: dispositivoId,
      });
      const alerta = {
        msg: "Dispositivo eliminado con exito",
        categoria: 'exito'
      }
      dispatch({
        type: DISPOSITIVO_OK,
        payload: alerta
      })
    } catch (error) {
      const alerta = {
        msg: error.response.data.message,
        categoria: "error",
      };

      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta,
      });
    }
  };

  // Aactualizar dispositivo
  const actualizarDispositivo = async (dispositivo) => {
    try {
      const resultado = await clienteAxios.put(
        `/dispositivos/${dispositivo.id}`,
        dispositivo
      );
      //console.log(resultado);
      // Actualizo el disp en el state
      dispatch({
        type: ACTUALIZAR_DISPOSITIVO,
        payload: resultado.data.dispositivo,
      });
      const alerta = {
        msg: "Dispositivo editado con exito",
        categoria: 'exito'
      }
      dispatch({
        type: DISPOSITIVO_OK,
        payload: alerta
      })
      return resultado;
    } catch (error) {
      const alerta = {
        msg: error.response.data.message,
        categoria: "error",
      };

      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta,
      });
    }
  };
  // Aactualizar dispositivo
  const actualizarMonitoreo = async (dispositivo) => {
    try {
      //old clienteAxios.
      const resultado = await serviceBack.put(
        `/dispositivos/monitoreo/${dispositivo._id}`,
        dispositivo
      );
      console.log(resultado);
      // Actualizo el disp en el state
      dispatch({
        type: ACTUALIZAR_DISPOSITIVO,
        payload: resultado.data.dispositivo,
      });
      const alerta = {
        msg: "Monitoreo actualizado con exito",
        categoria: 'exito'
      }
      dispatch({
        type: DISPOSITIVO_OK,
        payload: alerta
      })
      return resultado;
    } catch (error) {
      const alerta = {
        msg: 'No hemos podido actualizar el dispositivo',//error.response.data.message,
        categoria: "error",
      };

      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta,
      });
    }
  };
  /*
  * Para traer todos los dispositivos con paginacion, 
  * el segundo parametro debe llevar null
  */
  const infoDispositivos = async (clienteId, dispositivoId, pagina) => {
    try {
      let url="/dispositivos/info";
      if (clienteId){
        url=url + `?clienteId=${clienteId}`
      }
      if (dispositivoId){
        url= clienteId ? url +`&&dispositivoId=${dispositivoId}` : url +`?dispositivoId=${dispositivoId}`
      }
      const response = await clienteAxios.get(url,
        pagina ? {
          params: {
            pagina: pagina,
            tamanio: SIZE_PAGE,
          },
        } : null
      )
      if (response.data.dispositivo) {
        dispatch({
          type: OBTENER_DISPOSITIVO,
          payload: response.data.dispositivo,
        });
        return response.data.dispositivo

      } else if (response.data.dispositivos) {
        dispatch({
          type: OBTENER_DISPOSITIVOS,
          payload: response.data.dispositivos,
        });
        return response.data.dispositivos

      } else {
        dispatch({
          type: OBTENER_DISPOSITIVOS,
          payload: [],
        });
        dispatch({
          type: OBTENER_DISPOSITIVO,
          payload: null,
        });
        return

      }

    } catch (error) {
      const alerta = {
        msg: error,
        categoria: "error",
      };
      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta,
      });
    }
  }
  // muestra un error de validacion
  const errorDispositivo = (msj, categoria) => {
    const alerta = {
      msg: msj,
      categoria: categoria,
    };
    dispatch({
      type: DISPOSITIVO_ERROR,
      payload: alerta,
    });
  };
  // muestra un error de validacion
  const okDispositivo = (msj, categoria) => {
    const alerta = {
      msg: msj,
      categoria: categoria,
    };
    dispatch({
      type: DISPOSITIVO_OK,
      payload: alerta,
    });
  };
  // Obtengo un dispositivo por id
  const obtenerDispositivo = async (dispositivoId) => {
    try {
      const resultado = await clienteAxios.get(`/dispositivos?id=${dispositivoId}`);
      dispatch({
        type: OBTENER_DISPOSITIVO,
        payload: resultado.data.dispositivos[0] || null,
      });
      return resultado.data.dispositivos[0] || null;
    } catch (error) {
      const alerta = {
        msg: error.response.data.message,
        categoria: "error",
      };
      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta,
      });
    }
  };

  const actualizarLimiteAlertas = async(dispositivo, nuevoLimite) => {
    try {
      const resultado = await clienteAxios.put(
        `/limiteAlertas/${dispositivo.id}`,
        {
          limiteAlertas: nuevoLimite
        }
      );
      //console.log(resultado);
      // Actualizo el disp en el state
      
      const alerta = {
        msg: `Limite de alertas de "${dispositivo.nombre}" incrementado con exito`,
        categoria: 'exito'
      }
      dispatch({
        type: DISPOSITIVO_OK,
        payload: alerta
      })
      return resultado;
    } catch (error) {
      const alerta = {
        msg: error.message?error.message:"error",
        categoria: "error",
      };
      dispatch({
        type: DISPOSITIVO_ERROR,
        payload: alerta,
      });
    }
  }
  const clearOkDispositivo = () => {
    dispatch({
      type: DISPOSITIVO_OK,
      payload: null,
    });
  };
  const clearErrorDispositivo = () => {
    dispatch({
      type: DISPOSITIVO_ERROR,
      payload: null,
    });
  };
  return (
    <DispositivoContext.Provider
      value={{
        dispositivos: state.dispositivos,
        dispositivo: state.dispositivo,
        cliente: state.cliente,
        formulario: state.formulario,
        errorformulario: state.errorformulario,
        mensaje: state.mensaje,
        reload: state.reload,
        dispositivosSupervisados: state.dispositivosSupervisados,
        actualizarMonitoreo,
        obtenerDispositivos,
        agregarDispositivo,
        clearErrorDispositivo,
        clearOkDispositivo,
        dispositivoActual,
        eliminarDispositivo,
        actualizarDispositivo,
        errorDispositivo,
        okDispositivo,
        obtenerDispositivo,
        obtenerDispositivosSupervisados,
        obtenerDispositivosPoliciaSupervisados,
        infoDispositivos,
        actualizarLimiteAlertas,
        obtenerDispositivosInactividad
      }}
    >
      {props.children}
    </DispositivoContext.Provider>
  );
};
export default DispositivoState;
